<template>
  <div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">深圳罗湖区翠竹街道厨余垃圾处理智能管控系统</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <!-- <div class="model"> -->
        <!-- <div class="model_title">【企业介绍】</div> -->
        <!-- <div class="section"></div> -->
        <!-- </div> -->
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div>
            <div class="section">
              翠竹街道位于罗湖区的中部，东起爱国路，西至文锦路，南起爱国路与文锦路交会处，北至布心路，翠竹路横贯其中。辖区总面积3.446平方公里，下辖12个社区。为解决辖区垃圾分类后厨余垃圾的处理，配套新建厨余垃圾无害化处理中心。项目设计TJCG2-05型设备3台，TJCS1-5型设备1台,日处理厨余垃圾5吨。
            </div>
            <div class="section">
              <img src="../../assets/caseDetail/tianjiancase/1.png" alt="" />
            </div>
            <div class="section">
              项目采用智慧厨余设备，就近就地处理厨余垃圾，有效减少垃圾收运带来的成本与环境影响，对资源高效再利用，垃圾变肥为宝。设备连接云端平台，实时回传数据，安全性高。对设备运行数据实时监控，异常情况进行预报警推送，有效降低设备故障率。利用大数据平台实时处理区域数据，实时报告垃圾处理量，通过深度学习算法，构建环境数据模型，不断分析环境指标变化趋势。
            </div>
          </div>

          <div>
            <div class="section">平台运营管理</div>
            <div class="section">
              <img src="../../assets/caseDetail/tianjiancase/2.png" alt="" />
            </div>
          </div>

          <div>
            <div class="section">设备运行管理</div>
            <div class="section">
              <img src="../../assets/caseDetail/tianjiancase/3.png" alt="" />
            </div>
          </div>

          <div>
            <div class="section">售后服务效率分析</div>
            <div class="section">
              <img src="../../assets/caseDetail/tianjiancase/4.png" alt="" />
            </div>
          </div>

          <div>
            <div class="section">APP运维管理</div>
            <div class="imageContainer">
              <img src="../../assets/caseDetail/tianjiancase/5.png" alt="" />
              <img src="../../assets/caseDetail/tianjiancase/6.png" alt="" />
              <img src="../../assets/caseDetail/tianjiancase/7.png" alt="" />
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            1、减少垃圾收运成本与环境影响；
          </div>
          <div class="section">
            2、资源回收再利用，实现增收；
          </div>
          <div class="section">
            3、实时传送，降低系统故障率；
          </div>
          <div class="section">
            4、深度算法构建环境模型，多维度生成报表，便于政府监管；
          </div>
          <div class="section">
            5、高效运维体系建立，全流程把控，减少停机时间。
          </div>
          <div class="section">
            整合平台各项目设备运行数据，生成可视化数据分析图表，进行可视化集中管控，通过大屏可以直观的了解到平台各区域各项目的整体运行状况。从处理站趋势分析和总再生资源产量分析可以了解到区域的餐厨垃圾产生情况和垃圾处理再利用情况。从设备实时运行数据分析和故障预警分析可以实时了解设备全生命周期，可以有效提高设备迭代升级。设备的利用率和负荷量给运营人员带来了很好的数据参考价值，为后续的设备战略投放提供了重要的决策依据。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseTianjianDetail",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        // padding-left: 2.0em;
        img {
          width: 2.4rem;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseTianjianDetail1.vue